import { safeInitializeAuthorizer } from '@/auth/useAuthorizer'
import { useAuthStore } from '@/auth/useAuthStore'

import { getRedirectToLogin } from './common/getRedirectToLogin'
import { type HermesGuardFn } from './types'

export const checkAuthenticated: HermesGuardFn = async (to, from) => {
  const { meta = {} } = to

  const authStore = useAuthStore()

  // Resolve an unauthenticated (e.g. expired) session before any session
  // restore. Initializing the authorizer calls auth-service
  // (my-access/my-permissions); for an expired auth-service session those 401
  // and emit a logout mid-guard, which races this guard's own redirect on the
  // initial navigation and can strand the app on a blank screen. Redirecting
  // first lands an expired session cleanly on login.
  if (!meta.isPublic && !authStore.isAuthenticated) {
    return getRedirectToLogin(to)
  }

  if (
    !from?.name &&
    authStore.isAuthenticated &&
    authStore.user &&
    authStore.brandSession
  ) {
    await safeInitializeAuthorizer(
      authStore.user,
      authStore.brandSession,
      'sessionRestore',
      authStore.sessionProvider ?? undefined,
      () => authStore.csrfToken
    )

    const { useIntercomStore } = await import('@/core/public/useIntercomStore')
    void useIntercomStore().initializeIntercom()

    const { cobrowse } = await import('@/plugins/cobrowse')
    void cobrowse.init({
      app: 'hermes',
      brand: '',
      brandId: authStore.brandSession?.brandId ?? '',
      email: authStore.user.email ?? '',
      userName: `${authStore.user.firstName} ${authStore.user.lastName}`,
    })
  }

  if (meta.isPublic) {
    if (meta.preventAuthenticatedRedirect) return undefined

    if (authStore.isAuthenticated) return authStore.home
  }

  return undefined
}
